import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {IPGServiceModel, SortIPGServiceModel} from '../Model/IPGServiceModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const IPG_SERVICE_API = `${API_URL}/ipgServiceManager`

export const service = {
  getIPGService: (params: ParamsModel) => {
    return axios.get(IPG_SERVICE_API, {params})
  },
  getAllIPGService: () => {
    return axios.get(`${IPG_SERVICE_API}/list`)
  },

  addIPGService: (data: any) => {
    return axios.post(IPG_SERVICE_API, data)
  },

  updateIPGService: (body: IPGServiceModel, id: string) => {
    return axios.patch(`${IPG_SERVICE_API}/${id}`, body)
  },

  deleteIPGService: (data: {id: string}) => {
    return axios.delete(IPG_SERVICE_API, {data})
  },

  enableIPGService: (data: Array<string>) => {
    const selectedIPGService = {
      ipgServiceManagerId: data,
    }
    return axios.patch(`${IPG_SERVICE_API}/enable`, selectedIPGService)
  },

  disableIPGService: (data: Array<string>) => {
    const selectedIPGService = {
      ipgServiceManagerId: data,
    }
    return axios.patch(`${IPG_SERVICE_API}/disable`, selectedIPGService)
  },

  singleEnableIPGService: (data: Array<string>) => {
    const selectedIPGService = {
      ipgServiceManagerId: [data],
    }
    return axios.patch(`${IPG_SERVICE_API}/enable`, selectedIPGService)
  },

  singleDisableIPGService: (data: Array<string>) => {
    const selectedIPGService = {
      ipgServiceManagerId: [data],
    }
    return axios.patch(`${IPG_SERVICE_API}/disable`, selectedIPGService)
  },
  sortIPGService: (body: SortIPGServiceModel) => {
    return axios.patch(`${IPG_SERVICE_API}/sort`, body)
  },
}
